// TODO: compress the modals

import React from "react";

// react redux connect
import { connect } from 'react-redux';

// styled components
import styled from 'styled-components';

// react modal
import ReactModal from 'react-modal';

// material ui imports
import {
  CircularProgress,
  Card,
  CardContent,
  Grid,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

// icon imports
import LinkIcon from '@material-ui/icons/Link';
import BookIcon from '@material-ui/icons/Book';
import MapIcon from '@material-ui/icons/Map';

import { Redirect } from "react-router-dom";

// homemade component imports
import {
  RegularCard,
  A,
  P,
  CustomInput,
  Button,
  CardActions,
  UploadButton,
  ItemGrid,
} from "../../components";

// allows input of raw HTML for Article pages
import Editor from './Editor';

// reducer imports
import {
  loadArticles,
  getSettings,
  createNewArticle,
  editArticle,
  deleteArticle,
  createNewLink,
  deleteLink,
  editLink,
  createNewShortcut,
  editShortcut,
  deleteShortcut,
} from './reducer/actions';

// styled div
const ButtonContainer = styled.div`
  width: 100%;
  height: 100px;
  text-align: center;
  margin: 20px 3%;
`;

// card div style
const CARD = styled(Card)`
  width: 44%;
  height: 150px;
  background: #54b7e899 !important;
  text-align: center;
  margin: 20px 3%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.2) !important;
  }
`;

// modal div styles
const ModalContent = styled.div`
  position: relative;
  padding: 0px 20px;
  minHeight: 200px;
  overflow-y: scroll;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`

// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

// I'm Captain Basch fon Ronsenberg of Dalmasca!

// class declaration
// for schools, Mooses is imported as Customize page
// allowing Page, Link, and Shortcut buttons to be added to the application
class Mooses extends React.Component {
  // constructor
  constructor (props) {
    super(props);
    // set state
    this.state = {
      id: '',
      editorHtml: '',
      title: '',
      state: 'Create',
      showModal: null,
      image: null,
      background: null,
    };
    // binds
    this.initEditArticle = this.initEditArticle.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  // load articles and get settings upon load
  componentWillMount() {
    this.props.loadArticles();
    this.props.getSettings();
  }

  // change the contents of the block in the modal
  handleChange (html) {
    this.setState({ editorHtml: html });
  }

  // get settings, close modal
  onSuccess() {
    this.props.getSettings();
    this._onCloseModal();
  }

  // close modal, does not log error code
  onError() {
    this._onCloseModal();
  }

  // delete an article block
  onDeleteArticle(id) {
      this.props.deleteArticle(id, this.onSuccess.bind(this), this.onError.bind(this));
  }

  // delete a link block
  onLinkDelete(id) {
    this.props.deleteLink(id, this.onSuccess.bind(this), this.onError.bind(this));
  }

  // delete a link block
  onShortcutDelete(id) {
    this.props.deleteShortcut(id, this.onSuccess.bind(this), this.onError.bind(this));
  }

  // initialize editing an article by placing its contents in a Modal
  initEditArticle(id) {
    const { articles } = this.props;
    const curArticle = articles.filter(art => {
      return art.id === id
    })[0];

    this.setState({
      id: id,
      title: curArticle.title || '',
      buttonTitle: curArticle.buttonTitle || '',
      priority: curArticle.priority || 0,
      image: curArticle.image || null,
      editorHtml: curArticle.content || '',
      background: curArticle.background || null,
      state: 'Save',
      showModal: 'article'
    });
  }

  // when Edit is clicked on an Article,
  // change the original article to the new contents
  _onEditArticle () {
    this.props.editArticle(this.state.id, {
      id: this.state.id,
      title: this.state.title,
      buttonTitle: this.state.buttonTitle,
      image: this.state.image || null,
      priority: this.state.priority || 0,
      content: this.state.editorHtml,
      background: this.state.background || null,
    }, this.onSuccess.bind(this), this.onError.bind(this));
  }

  // when Create is clicked on a modal, make a brand new article
  _onAddNewArticle () {
    this.props.createNewArticle({
      title: this.state.title || '',
      buttonTitle: this.state.buttonTitle || '',
      priority: this.state.priority || 0,
      image: this.state.image || null,
      content: this.state.editorHtml || ''
    }, this.onSuccess.bind(this), this.onError.bind(this));
  }

  // add a new Link to a website
  addNewLink() {
    this.props.createNewLink({
      title: this.state.title || '',
      link: this.state.link || '',
      priority: this.state.priority || 0,
      openLinkInBrowser: this.state.openLinkInBrowser,
    }, this.onSuccess.bind(this), this.onError.bind(this));
    this.onSuccess();
  }

  // change a link to a website
  onEditLink() {
    this.props.editLink(
      this.state.id, {
        id: this.state.id,
        title: this.state.title || '',
        link: this.state.link || '',
        priority: this.state.priority || 0,
        openLinkInBrowser: this.state.openLinkInBrowser || false,
        background: this.state.background || null,
      }, this.onSuccess.bind(this), this.onError.bind(this));

  }

  // add a new Shortcut to a Screen in app
  addNewShortcut() {
    this.props.createNewShortcut({
      title: this.state.title || '',
      screen: this.state.link || '',
      priority: this.state.priority || 0,
    }, this.onSuccess.bind(this), this.onError.bind(this));
    this.onSuccess();
  }

  // change a link to a website
  onEditShortcut() {
    this.props.editShortcut(
      this.state.id, {
        id: this.state.id,
        title: this.state.title || '',
        screen: this.state.link || '',
        priority: this.state.priority || 0,
        background: this.state.background || null,
      }, this.onSuccess.bind(this), this.onError.bind(this));

  }

  // show the Article create/edit modal
  showArticleModal() {
    this.setState({
      title: '',
      buttonTitle: '',
      priority: 0,
      editorHtml: '',
      image: null,
      state: 'Create',
      showModal: 'article'
    });
  }

  // show the Link create/edit modal
  showLinkModal() {
    this.setState({
      title: '',
      link: '',
      priority: 0,
      openLinkInBrowser: false,
      state: 'Create',
      showModal: 'link'
    });
  }

  // show the Shortcut create/edit modal
  showShortcutModal() {
    this.setState({
      title: '',
      link: '',
      priority: 0,
      state: 'Create',
      showModal: 'shortcut'
    });
  }

  // find the Link to be edited from props and allow it to be Edited
  // this is effectively initEditLink, but also, not, I don't get it either
  showLinkUpdateModal(id) {
    const { links } = this.props.settings;

    const { title, link, priority, openLinkInBrowser, background } = links[id];

    this.setState({
      id,
      title,
      link,
      openLinkInBrowser,
      priority,
      background,
      state: 'Save',
      showModal: 'link'
    });
  }

  // find Shortcut in Props and enable editing
  showShortcutUpdateModal(id) {
    const { shortcuts } = this.props.settings;

    const {
      title,
      screen,
      priority,
      background
    } = shortcuts[id];

    this.setState({
      id: id,
      title: title,
      link: screen,
      priority: priority,
      background: background,
      state: 'Save',
      showModal: 'shortcut'
    });
  }

  // close the modal
  _onCloseModal() {
    this.setState({ showModal: null });
  }

  // render the individual Link/Article cards
  renderCards() {
    const {
      links = {},
      shortcuts = {},
    } = this.props.settings || {};
    // get articles
    const { articles } = this.props;
    // get links
    const linksArray = Object.keys(links).map(id => ({...links[id], id, isLink: true}));
    // get shortcuts
    const shortcutsArray = Object.keys(shortcuts).map(id => ({...shortcuts[id], id, isLink: false}));
    // sort and map accordingly
    return [...linksArray, ...shortcutsArray, ...articles]
      .sort((a,b) => a.priority - b.priority)
      .map(v =>
        v.isLink ?
          this.renderLink(v) :
          v.screen ?
            this.renderShortcut(v):
            this.renderArticle(v)
      )
  }

  // render a Link
  renderLink(link) {
    return (
      <CARD key={link.id}>
        {/* upper left box */}
        <div style={{
          width: 60,
          height: 60,
          position: 'absolute',
          top: 5,
          left: 5,
          borderRadius: 15,
          backgroundColor: 'white',
        }}>
          {/* icon indicator */}
          <LinkIcon />
          {/* Priority of icon in parentheses */}
          <div style={{fontWeight: 'bold'}}>
            { link.priority != null ?
              ` (${link.priority})`
              : ''
            }
          </div>
        </div>
        {/* Title of Link button, if applicable */}
        <CardContent>
          <div style={{
            position: 'absolute',
            right: 5,
            bottom: 10,
            paddingBottom: 15,
            width: 150,
            height: 20
          }}>
            {link.title}
          </div>
        </CardContent>
        {/* on mouse over floating Edit/Delete buttons */}
        <CardActions
          requireModal
          edit={() => this.showLinkUpdateModal(link.id)}
          delete={() => this.onLinkDelete(link.id)}
          onMouseEnter={this.showActionHandler}
          onMouseLeave={this.hideActionHandler}
        />
        {/* Upload Button for image on upper right */}
        <UploadButton
          storage="friends"
          style={{
            width: 150,
            height: 100,
            position: 'absolute',
            top: 5,
            right: 5,
            borderRadius: 3,
          }}
          value={link.background}
          onUploadComplete={background => this.props.editLink(
            link.id, {
              ...link,
              background,
            },
            this.onSuccess.bind(this),
            this.onError.bind(this))
          }
        />
      </CARD>
    )
  } // end of renderLink

  // render a shortcut
  renderShortcut(shortcut) {
    return (
      <CARD key={shortcut.id}>
        {/* upper left box */}
        <div style={{
          width: 60,
          height: 60,
          position: 'absolute',
          top: 5,
          left: 5,
          borderRadius: 15,
          backgroundColor: 'white',
        }}>
          {/* icon indicator */}
          <MapIcon />
          {/* Priority of icon in parentheses */}
          <div style={{fontWeight: 'bold'}}>
            { shortcut.priority != null ?
              ` (${shortcut.priority})`
              : ''
            }
          </div>
        </div>
        {/* Title of Shortcut button, if applicable */}
        <CardContent>
          <div style={{
            position: 'absolute',
            right: 5,
            bottom: 10,
            paddingBottom: 15,
            width: 150,
            height: 20
          }}>
            {shortcut.title}
          </div>
        </CardContent>
        {/* on mouse over floating Edit/Delete buttons */}
        <CardActions
          requireModal
          edit={() => this.showShortcutUpdateModal(shortcut.id)}
          delete={() => this.onShortcutDelete(shortcut.id)}
          onMouseEnter={this.showActionHandler}
          onMouseLeave={this.hideActionHandler}
        />
        {/* Upload Button for image on upper right */}
        <UploadButton
          storage="friends"
          style={{
            width: 150,
            height: 100,
            position: 'absolute',
            top: 5,
            right: 5,
            borderRadius: 3,
          }}
          value={shortcut.background}
          onUploadComplete={background => this.props.editShortcut(
            shortcut.id, {
              ...shortcut,
              background,
            },
            this.onSuccess.bind(this),
            this.onError.bind(this))
          }
        />
      </CARD>
    )
  } // end of renderShortcut

  // render an Article
  renderArticle(article) {
    return (
      <CARD key={article.id}>
        {/* upper left block */}
        <div style={{
          width: 60,
          height: 60,
          position: 'absolute',
          top: 5,
          left: 5,
          borderRadius: 15,
          backgroundColor: 'white',
        }}>
          {/* Article indicator icon */}
          <BookIcon />
          {/* Article's Priority in parentheses */}
          <div style={{fontWeight: 'bold'}}>
            { article.priority != null ?
              ` (${article.priority})`
              : ''
            }
          </div>
        </div>
        {/* Title of Article */}
        <CardContent>
          <div style={{
            position: 'absolute',
            right: 5,
            bottom: 10,
            paddingBottom: 15,
            width: 150,
            height: 20
          }}>
            {article.buttonTitle || article.title}
          </div>
        </CardContent>
        {/* Lower left Article Image block */}
        <div
          style={{
            width: 150,
            height: 60,
            position: 'absolute',
            bottom: 5,
            left: 5,
            borderRadius: 10,
            backgroundColor: '#ccc',
            backgroundImage: `url("${article.image}")`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%'
          }}
        />
        {/* Edit/Delete float over buttons */}
        <CardActions
          edit={() => this.initEditArticle(article.id)}
          delete={() => this.onDeleteArticle(article.id)}
          onMouseEnter={this.showActionHandler}
          onMouseLeave={this.hideActionHandler}
          requireModal
        />
        {/* upper right upload button for button image */}
        <UploadButton
          storage="friends"
          style={{
            width: 150,
            height: 100,
            position: 'absolute',
            top: 5,
            right: 5,
            borderRadius: 3,
          }}
          value={article.background}
          onUploadComplete={background => this.props.editArticle(
            article.id, {
              ...article,
              background,
            },
            this.onSuccess.bind(this),
            this.onError.bind(this))
          }
        />
      </CARD>
    )
  } // end of renderArticle

  // render the Article creation modal
  renderArticleModal() {
    return (
      <ReactModal
        isOpen={this.state.showModal === 'article'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Article' : 'New Article'}
        ariaHideApp={false}
        style={customModalStyles}
      >
        <ModalContent>
          <Grid container>
            <ItemGrid xs={12} sm={8}>
              {/* Button Label input field*/}
              <CustomInput
                labelText="Button Label"
                id="buttonTitle"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.buttonTitle,
                  onChange: (evt) => {this.setState({buttonTitle: evt.target.value})}
                }}
              />
            </ItemGrid>
            {/* Upload article header image*/}
            <ItemGrid xs={12} sm={4}>
              <UploadButton
                storage="friends"
                style={{marginTop: '2rem'}}
                value={this.state.image}
                onUploadComplete={uri => this.setState({ image: uri })}
              />
            </ItemGrid>
            {/* Article Title */}
            <ItemGrid xs={12} sm={12}>
              <CustomInput
                labelText="Title"
                id="title"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.title,
                  onChange: (evt) => {this.setState({title: evt.target.value})}
                }}
              />
            </ItemGrid>
            {/* Article Priority */}
            <ItemGrid xs={12} sm={12}>
            <CustomInput
              labelText="Priority"
              id="priority"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: this.state.priority,
                onChange: (evt) => {this.setState({priority: evt.target.value})}
              }}
            />
            </ItemGrid>
          </Grid>
          {/* Text Input section for Article that accepts HTML */}
          <div style={{display: 'flex'}}>
            <Editor
              handleChange={this.handleChange}
              value={this.state.editorHtml}
            />
          </div>
        </ModalContent>
        {/* buttons */}
        <ModalFooter>
          {/* Save Changes button */}
          {this.state.state === 'Save' &&
            <Button onClick={() => {this._onEditArticle()}}>Save</Button>
          }
          {/* Create New Article button */}
          {this.state.state !== 'Save' &&
            <Button onClick={() => {this._onAddNewArticle()}}>Create</Button>
          }
          {/* Cancellation button */}
          <Button onClick={() => {this._onCloseModal()}}>Cancel</Button>
        </ModalFooter>
      </ReactModal>
    );
  } // end of Render Article Modal

  // render the Link Create/Edit modal
  renderLinkModal() {
    return (
      <ReactModal
        isOpen={this.state.showModal === 'link'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Link' : 'New Link'}
        ariaHideApp={false}
        style={customModalStyles}
        >
        <ModalContent>
          <Grid container>
            {/* Title input field */}
            <ItemGrid xs={12} sm={12}>
              <CustomInput
                labelText="Title"
                id="title"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.title,
                  onChange: (evt) => {this.setState({title: evt.target.value})}
                }}
              />
            </ItemGrid>
            {/* URL to link input field */}
            <ItemGrid xs={12} sm={12}>
              <CustomInput
                labelText="Link"
                id="link"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.link,
                  onChange: (evt) => {this.setState({link: evt.target.value})}
                }}
              />
              {/* Button Priority input field */}
              <CustomInput
                labelText="Priority"
                id="priority"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.priority,
                  onChange: (evt) => {this.setState({priority: evt.target.value})}
                }}
              />
            {/* Whether or not the link should be opened in a browser or in the app */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.openLinkInBrowser}
                    onChange={(e, c) => {this.setState({ openLinkInBrowser: c })}}
                    value="checkedAD" />
                }
                label="Open link in browser"
              />
            </ItemGrid>
          </Grid>
        </ModalContent>
        <ModalFooter>
          {/* Save edits to Link button */}
          {this.state.state === 'Save' &&
            <Button onClick={() => this.onEditLink()}>Save</Button>
          }
          {/* Create new Link button */}
          {this.state.state !== 'Save' &&
            <Button onClick={() => this.addNewLink()}>Create</Button>
          }
          {/* Cancel button */}
          <Button onClick={() => {this._onCloseModal()}}>Cancel</Button>
        </ModalFooter>
      </ReactModal>
    );
  } // end of renderLinkModal

  // render the Shortcut Create/Edit modal
  renderShortcutModal() {
    return (
      <ReactModal
        isOpen={this.state.showModal === 'shortcut'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Shortcut' : 'New Shortcut'}
        ariaHideApp={false}
        style={customModalStyles}
        >
        <ModalContent>
          <Grid container>
            {/* Title input field */}
            <ItemGrid xs={12} sm={12}>
              <CustomInput
                labelText="Title"
                id="title"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.title,
                  onChange: (evt) => {this.setState({title: evt.target.value})}
                }}
              />
            </ItemGrid>
            {/* URL to link input field */}
            <ItemGrid xs={12} sm={12}>
              <CustomInput
                labelText="Shortcut To:"
                id="shortcut"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.link,
                  onChange: (evt) => {this.setState({link: evt.target.value})}
                }}
              />
              {/* Button Priority input field */}
              <CustomInput
                labelText="Priority"
                id="priority"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.priority,
                  onChange: (evt) => {this.setState({priority: evt.target.value})}
                }}
              />
            </ItemGrid>
          </Grid>
        </ModalContent>
        <ModalFooter>
          {/* Save edits to Link button */}
          {this.state.state === 'Save' &&
            <Button onClick={() => this.onEditShortcut()}>Save</Button>
          }
          {/* Create new Link button */}
          {this.state.state !== 'Save' &&
            <Button onClick={() => this.addNewShortcut()}>Create</Button>
          }
          {/* Cancel button */}
          <Button onClick={() => {this._onCloseModal()}}>Cancel</Button>
        </ModalFooter>
      </ReactModal>
    );
  } // end of renderShortcutModal

  // main render function
  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'customize'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('customize'))
    {
      return (
        <Redirect from={'customize'} to={'dashboard'} key={'noTicket'} />
      );
    }

    return (
      // header
      <RegularCard
        cardTitle="Community"
        cardSubtitle={
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <P>
              Made by users from{" "}
              <A target="_blank" href="">
                GK-Membership
              </A>{" "}
              and organized by{" "}
              <A target="_blank" href="">
                GK
              </A>. Please checkout the{" "}
              <A href="#an" target="_blank">
                full documentation
              </A>.
            </P>
            <div>
            { this.props.isLoading && <CircularProgress /> }
            </div>
          </div>
        }
        content={
          <div style={{display: 'flex', flexWrap: 'wrap', margin: 'auto'}}>
            {/* display modals */}
            {
              this.state.showModal === 'article' ? this.renderArticleModal() :
              this.state.showModal === 'link' ? this.renderLinkModal() :
              this.state.showModal === 'shortcut' ? this.renderShortcutModal() :
              null
            }
            {/* render all existing cards */}
            {this.renderCards()}
            <ButtonContainer>
              {/* New Article button */}
              <Button
                style={{width: 170, height: 50}}
                onClick={() => this.showArticleModal()}
               >
                ADD NEW ARTICLE
                <BookIcon
                  style={{marginLeft: 3}}
                />
              </Button>
              {/* New Link button */}
              <Button
                style={{minWidth: 150, height: 50, marginLeft: 20}}
                onClick={() => this.showLinkModal()}
               >
                ADD NEW LINK
                <LinkIcon
                  style={{marginLeft: 3}}
                />
              </Button>
              {/* New Shortcut button */}
              <Button
                style={{minWidth: 170, height: 50, marginLeft: 20}}
                onClick={() => this.showShortcutModal()}
               >
                ADD NEW SHORTCUT
                <MapIcon
                  style={{marginLeft: 3}}
                />
              </Button>
            </ButtonContainer>
          </div>
        }
      />
    ) // end of return
  } // end of render
} // end of class declaration

// map dispatch
const mapDispatchToProps = {
  loadArticles,
  getSettings,
  createNewArticle,
  editArticle,
  deleteArticle,
  createNewLink,
  deleteLink,
  editLink,
  createNewShortcut,
  editShortcut,
  deleteShortcut,
};
// map state
const mapStateToProps = state => ({
  articles: state.mooseReducer.articles,
  settings: state.mooseReducer.settings,
  isLoading: state.mooseReducer.isLoading,
  user: state.authReducer.user,
  loggedIn: state.authReducer.loggedIn,
});
// export and connect
export default connect(mapStateToProps, mapDispatchToProps)(Mooses);
